export const environment = {
    GOOGLESHEETS_PRIVATEKEY: process.env.GATSBY_GOOGLESHEETS_PRIVATEKEY,
    GOOGLESHEETS_CLIENT_EMAIL: process.env.GATSBY_GOOGLESHEETS_CLIENT_EMAIL,
}